export default {
  'booking.exporter': 'المصدر',
  'booking.issueDate': 'تاريخ الإصدار',
  'booking.email': 'البريد الإلكتروني',
  'booking.PassengerNameInEnglish': 'اسم المسافر بالإنجليزية',
  'booking.PassengerLastNameInEnglish': 'اللقب بالإنجليزية',
  'booking.NationalityOfThePassenger': 'جنسية المسافر',
  'booking.genderOfThePassenger': 'جنس المسافر',
  'booking.LoginToAccount': 'تسجيل الدخول إلى الحساب',
  'booking.userGoForCreateAccount':
    'إذا لم يكن لديك حساب، قم بإنشاء حساب الآن واستفد من فوائد نادي الزبائن تريبسي.',
  'booking.continuWithGuestUser':
    'إذا واصلت كمستخدم زائر، فلن تستفيد من امتيازات نادي الزبائن.',
  'booking.totalsales': 'إجمالي المبيعات حسب العداد',
  'booking.FirstPassenger': 'أول مسافر',
  'booking.totalpriceofpassengers': ' السعر الإجمالي للراكب ',
  'booking.ticketPriceDetails': 'تفاصيل سعر التذكرة',
  'booking.pricedetails': 'تفاصيل السعر',
  'booking.toViewTheListOfPreviousPassengers': 'لعرض قائمة المسافرين السابقين',
  'booking.pleaselogin': 'من فضلك',
  'booking.travelerdetails': 'تفاصيل المسافر',
  'booking.buy_ticket': 'شراء التذكرة',
  'booking.wheretogo': 'إلى أين تريد الذهاب؟',
  'booking.searchflight': 'البحث عن رحلة',
  'booking.selectflight': 'اختيار الرحلة',
  'booking.oneway': 'اتجاه واحد',
  'booking.onewaytrip': 'ذهاب',
  'booking.roundtrip': 'ذهاب وعودة',
  'booking.multicity': ' مدن متعددة ',
  'booking.bestguarantee': 'أفضل الأسعار مضمونة عبر الإنترنت',
  'booking.getdeals': 'احصل على عروض',
  'booking.signupnow': 'سجل الآن',
  'booking.from': 'من',
  'booking.to': 'إلى',
  'booking.guest': 'زائر',
  'booking.city': 'مدينة',
  'booking.country': 'بلد',
  'booking.Adult': 'البالغين',
  'booking.adult': 'البالغين',
  'booking.Child(Age 212)': 'طفل (العمر 212)',
  'booking.Infant(Age 02)': ' الرُضع  (العمر 02)',
  'booking.senior': 'مسن',
  'booking.senior(Over 65)': 'مسن (أكثر من 65)',
  'booking.students': 'طلاب',
  'booking.students(Over 18)': 'طلاب (أكثر من 18)',
  'booking.toddler': 'طفل صغير',
  'booking.toddler(Age 02)': 'طفل صغير في مقعده',
  'booking.guestsandcities': 'الزوار والمدن',
  'booking.startover': 'ابدأ من جديد',
  'booking.showmoredate': 'إظهار المزيد من التواريخ',
  'booking.selectdate': 'اختيار التاريخ',
  'booking.date': 'تاريخ',
  'booking.changedate': 'تغيير التاريخ',
  'booking.airline': 'شركات ال',

  'booking.departs': 'المغادرة',
  'booking.arrives': 'الوصول',
  'booking.duration': 'المدة الزمنية',
  'booking.travelclass': 'الفئة',
  'booking.priceperadult': 'سعر البالغ',
  'booking.priceperchild': 'سعر الطفل',
  'booking.priceperinfant': 'سعر الرضيع',
  'booking.flightnumber': 'رقم الرحلة',
  'booking.remainseat': 'المقاعد المتبقية',
  'booking.cost': 'التكلفة',
  'booking.showmore': 'عرض المزيد',
  'booking.birthyear': 'سنة الميلاد',
  'booking.birthmonth': 'شهر الميلاد',
  'booking.birthday': 'يوم الميلاد',
  'booking.passportno': 'رقم جواز السفر',
  'booking.birthcountry': 'بلد الميلاد',
  'booking.passportcountry': 'الجنسية',
  'booking.passportexpireyear': 'سنة انتهاء الجواز',
  'booking.passportexpiremonth': 'شهر انتهاء الجواز',
  'booking.passportexpireday': 'يوم انتهاء الجواز',
  'booking.completeform': 'يرجى ملء الاستمارة للمتابعة',
  'booking.changeavatar': 'تغيير الصورة الرمزية',
  'booking.passengerinfo': 'معلومات المسافر',
  'booking.isiranian': 'إيراني',
  'booking.othernationality': 'جنسية أخرى',
  'booking.perviousepassenger': 'اختر من قائمة المسافرين السابقين',
  'booking.index': 'فهرس',
  'booking.primarytraveler': 'المسافر الأساسي',
  'booking.adultinformation': 'معلومات البالغ',
  'booking.childinformation': 'معلومات الطفل',
  'booking.infantinformation': 'معلومات الرضيع',
  'booking.phone': 'رقم الهاتف',
  'booking.totalamount': 'السعر الكلي',
  'booking.showreserve': 'عرض الحجز',
  'booking.stopcount': 'التوقف',
  'booking.airplanetype': 'الطائرة',
  'booking.international': 'دولي',
  'booking.domestic': 'محلي',
  'booking.notexist': 'غير موجود',
  'booking.noavailableflight': 'لا توجد رحلات متاحة',
  'booking.departurecities': 'مدينة المغادرة',
  'booking.returncities': 'مدينة العودة',
  'booking.departuredate': 'تاريخ المغادرة',
  'booking.returndate': 'تاريخ العودة',
  'booking.departuretime': 'وقت المغادرة',
  'booking.returntime': 'وقت العودة',
  'booking.paynow': 'ادفع الآن',
  'booking.sigin': 'تسجيل الدخول',
  'booking.signup': 'الاشتراک',
  'booking.notregister': 'ليس مسجلاً',
  'booking.elevatemembers': 'أعضاء الارتقاء',
  'booking.departureflightinfo': 'معلومات المغادرة',
  'booking.returnflightinfo': 'معلومات العودة',
  'booking.previouspassenger': 'المسافرين السابقين',
  'booking.hi': 'مرحبًا،',
  'booking.travelwith': 'أنت تسافر مع',
  'booking.ticket': 'سيتم إصدار تذكرتك قريبًا',
  'booking.successpayment': 'تمت عملية الدفع بنجاح',
  'booking.previousepassengerlist': 'قائمة المسافرين السابق',
  'booking.bookingflights': 'حجز الرحلات',
  'booking.flightno': 'رقم الرحلة',
  'booking.child': 'طفل',
  'booking.infant': 'الرُضع',
  'booking.male': 'ذكر',
  'booking.female': 'أنثى',
  'booking.departureflight': 'رحلة الذهاب',
  'booking.returnflight': 'رحلة العودة',
  'booking.importantTips': 'نصائح مهمة',
  'booking.passengerArrivringTip':
    'يجب على الراكب الوصول إلى المطار قبل 4 ساعات من موعد الرحلة لاستكمال إجراءات الصعود في الوقت المحدد',
  'booking.payTextTip':
    'ادفع رسوم الخروج عبر الإنترنت من خلال بوابة بنك ملي السداد لتجنب التأخير في المطار',
  'booking.showticket': 'عرض التذاكر',
  'booking.cancel': 'إلغاء',
  'booking.passengers': 'الركاب',
  'booking.price': 'السعر',
  'booking.returnprice': 'سعر العودة',
  'booking.cancelstatus': 'الحالة',
  'booking.cancelreason': 'لماذا تريد إلغاء تذكرتك؟',
  'booking.personalproblem': 'مشكلة شخصية (بناءً على قواعد الطيران)',
  'booking.airlineproblem': 'إلغاء الرحلة من قبل الشركة الجوية',
  'booking.flightproblem': 'تأخير أو إسراع لأكثر من 2 ساعة',
  'booking.back': 'رجوع',
  'booking.nextstep': 'الخطوة التالية',
  'booking.previousstep': 'الخطوة السابقة',
  'booking.cancelingrules': 'قواعد الإلغاء',
  'booking.wait': 'يرجى الانتظار ......',
  'booking.flights': 'الرحلات',
  'booking.cancelpayment': 'فشلت عملية الدفع الخاصة بك',
  'booking.refid': 'رمز التتبع الخاص بك هو: ',
  'booking.airport': 'المطارات',
  'booking.flighttime': 'وقت الرحلة',
  'booking.flightstopcount': 'التوقفات',
  'booking.morning': 'الصباح (من 0 حتى 8)',
  'booking.noon': 'الظهيرة (من 8 حتى 14)',
  'booking.afternoon': 'المساء (من 14 حتى 20)',
  'booking.night': 'الليل (بعد الساعة 20)',
  'booking.sort': 'الترتيب',
  'booking.sortbyprice': 'حسب السعر',
  'booking.sortbytime': 'حسب الوقت',
  'booking.sortbypoint': 'حسب النقطة',
  'booking.nonstop': 'مباشرة',
  'booking.onestop': 'توقف واحد',
  'booking.morethanonestop': 'أكثر من توقف واحد',
  'booking.origin': 'المغادرة',
  'booking.destination': 'الوجهة',
  'booking.startdate': 'تاريخ البدء',
  'booking.enddate': 'تاريخ الانتهاء',
  'booking.search': 'بحث',
  'booking.filter': 'تصفية',
  'booking.agree': 'أوافق',
  'booking.cancelrules': 'قواعد الإلغاء',
  'booking.flightscount': ' الرحلات الموجودة!',
  'booking.clearfilter': 'مسح',
  'booking.gifavatar': 'صورة متحركة',
  'booking.avatar': 'الصورة الرمزية',
  'booking.notfound': 'لم يتم العثور على أية مدينة',
  'booking.nextyear': 'العام القادم',
  'booking.previousyear': 'العام السابق',
  'booking.details': 'التفاصيل',
  'booking.adultprice': 'السعر للكبار',
  'booking.sortby': 'ترتيب حسب',
  'booking.bydescendingprice': 'السعر',
  'booking.byascendingprice': 'السعر',
  'booking.bydescendingpoint': 'النقاط',
  'booking.byascendingpoint': 'النقاط',
  'booking.byascendingduration': 'المدة',
  'booking.bydescendingduration': 'المدة',
  'booking.bydescendingtime': 'وقت الإقلاع',
  'booking.byascendingarrivetime': 'وقت الوصول',
  'booking.bydescendingarrivetime': 'وقت الوصول',
  'booking.byascendingtime': 'وقت الإقلاع',
  'booking.justthis': 'فقط',
  'booking.searchpassenger': 'أنت تبحث عن... ',
  'booking.edit': 'تحرير',
  'booking.select': 'اختيار',
  'booking.gotoday': 'انطلق اليوم',
  'booking.pricedetail': 'تفاصيل السعر',
  'booking.passengertype': 'النوع',
  'booking.fareprice': 'سعر التذكرة',
  'booking.tax': 'الضريبة',
  'booking.allairport': ' ( جميع المطارات ) ',
  'booking.moneyunit': '(جميع الأسعار بالدولار)',
  'booking.noseatresult': 'لا توجد مقاعد',
  'booking.today': 'اليوم',
  'booking.terminal': 'المحطة',
  'booking.sumprice': 'السعر الإجمالي',
  'booking.sameairport': "يرجى إدخال مطار 'من' و 'إلى' فريد.",
  'booking.stopin': 'التوقف في',
  'booking.megaleapyearsale': 'تخفيضات ميجا للسنة الكبيسة',
  'booking.planasunnyd1': 'قم بالتخطيط لقضاء عطلة مشمسة الآن ووفر',
  'booking.planasunnyd2': 'تخفيضات نادرة بنسبة 29٪.',
  'booking.restrictionsapply': 'تطبق القيود',
  'booking.grabaseat': 'احجز مقعدًا',
  'booking.enjoywithbestfriends': 'استمتع مع أفضل الأصدقاء',
  'booking.helpafriendd1': 'ساعد صديقًا في الانفصال عن برنامج الولاء الخاص بهم',
  'booking.helpafriendd2': 'واحصل على نقاط Elevate',
  'booking.termsandconditionsapply': 'تطبق الشروط والأحكام',
  'booking.bookhotels': 'حجز فنادق',
  'booking.booktours': 'حجز جولات سياحية',
  'booking.takeofffaster': 'الإقلاع بشكل أسرع',
  'booking.earn10kpointsd1': 'اكسب 10 ألف نقطة مع بطاقة IAM TOURIST',
  'booking.earn10kpointsd2': 'Visa Signature.',
  'booking.weathertoday': 'الطقس اليوم',
  'booking.learnmore': 'تعرف على المزيد',
  'booking.swipeforthesky': 'اسحب للسماء',
  'booking.getsetforamorerewardingexperienceonthegroundandinthesky':
    'استعد لتجربة أكثر إثراءً على الأرض وفي السماء مع بطاقة IAM TOURIST Visa Signature® الجديدة.',
  'booking.firstoneonfirstoneoff': 'الأول داخل، الأول خارج',
  'booking.inahurry':
    'في عجلة من أمرك؟ انطلق مباشرةً إلى السيارة مع مقعد الدرجة الرئيسية المفضل نحو مقدمة الطائرة، أو امنح نفسك الأولوية في الأمان والصعود إلى الطائرة مقابل رسوم رمزية.',
  'booking.feeltheupgrade': 'اشعر بالترقية.',
  'booking.travelinstylewithextralegroom':
    'سافر بأناقة مع مساحة إضافية للساقين، والصعود والأمان بأولوية، والمزيد في الدرجة الرئيسية المحددة. عش حياتك بأفضل طريقة.',
  'booking.takethefasttrack': 'اختر الطريق السريع.',
  'booking.breezethroughsecuritylikeyouowntheplace':
    'تمر بسلاسة عبر التفتيش الأمني وكأنك صاحب المكان مع فحص TSA Pre✓™ الميسّر. اكتشف كيفية الاستمتاع بالفوائد.',
  'booking.corporaterewards': 'مكافآت الشركات',
  'booking.abetterflighttoyournextmeetingdoesn’thavetobeanextravagance':
    'لا يجب أن تكون الرحلة إلى اجتماعك القادم ترفًا. Elevate, Inc.، هو برنامج المكافآت الخاص بنا للشركات الذي يمنح عملك شيئًا صغيرًا مقابل ما تنفقه على السفر.',
  'booking.packyourpoints': 'احزم نقاطك.',
  'booking.livelargeat35,000feet':
    'عش حياة كبيرة على ارتفاع 35,000 قدم. انضم إلى Elevate وابدأ في تجميع النقاط والمزايا ورحلات الجوائز دون تاريخ توقف.',
  'booking.allpassengerprice': 'السعر الإجمالي لجميع الركاب',
  'booking.baggages': 'الأمتعة',
  'booking.orderdate': 'تاريخ الطلب',
  'booking.traveldate': 'تاريخ السفر',
  'booking.passengername': 'الاسم',
  'booking.invoice': 'الفاتورة',
  'booking.totalprice': 'السعر الإجمالي',
  'booking.cancelticket': 'إلغاء التذكرة',
  'booking.operatedairline': 'الشركة الطيران المشغلة',
  'booking.count': 'العدد',
  'booking.departureflighttime': 'وقت الإقلاع',
  'booking.returnflighttime': 'وقت العودة',
  'booking.returnstopcount': 'عدد التوقفات في العودة',
  'booking.pc': 'قطعة',
  'booking.kg': 'كغ',
  'booking.cabin': 'المقصورة',
  'booking.layoverairports': 'مطارات التوقف الطويل',
  'booking.includeairports': 'تضمين المطارات',
  'booking.departduration': 'مدة الرحيل',
  'booking.returnduration': 'مدة العودة',
  'booking.nightcount': 'ليلة',
  'booking.nights': 'ليالٍ',
  'booking.showflightdetail': 'عرض التفاصيل',
  'booking.toman': 'تومان',
  'booking.free': 'مجاني',
  'booking.hour': 'ساعة',
  'booking.minutes': 'دقيقة',
  'booking.and': 'و',
  'booking.nobaggage': 'بدون أمتعة',
  'booking.mainterminal': 'المحطة الرئيسية',
  'booking.shamsi': 'شمسي',
  'booking.miladi': 'ميلادي',
  'booking.adultageerror': 'يجب أن يكون عمر البالغ أكثر من 12 عامًا',
  'booking.seniorageerror': 'يجب أن يكون عمر المسن أكثر من 60 عامًا',
  'booking.toddlerageerror': 'يجب أن يكون عمر الطفل دون سنتين',
  'booking.childageerror': 'يجب أن يكون عمر الطفل أكثر من 2 وأقل من 12 عامًا',
  'booking.infantageerror': 'يجب أن يكون عمر الرضيع أقل من سنتين',
  'booking.passenger': 'الراكب',
  'booking.important': 'مهم!',
  'booking.identifynote':
    'يجب كتابة اسم الراكب باللغة الإنجليزية بالضبط كما هو مكتوب في جواز السفر.',
  'booking.validpassportdate':
    'يجب أن تنتهي صلاحية جواز السفر الخاص بك بعد مرور 6 أشهر.',
  'booking.adt': 'البالغين',
  'booking.chd': 'طفل',
  'booking.inf': 'الرُضع',
  'booking.passcount': 'عدد الركاب',
  'booking.departure': 'المغادرة',
  'booking.return': 'العودة',
  'booking.allflightinformation': 'كل معلومات الرحلة',
  'booking.notavailable': 'غير متوفر',
  'booking.previousemonth': 'الشهر السابق',
  'booking.nextmonth': 'التالي',
  'booking.passportexpiredate': 'تاريخ انتهاء الجواز',
  'booking.arrivein': 'وصول في',
  'booking.nextdays': 'اليوم التالي',
  'booking.clearallfilter': 'مسح كل الفلاتر',
  'booking.duplicatepassenger': 'الرقم الوطني أو رقم جواز السفر مكرر',
  'booking.policy': 'لقد قرأت ووافقت على شروط',
  'booking.changecontact': 'سيتم إرسال معلومات التذكرة إلى:',
  'booking.customeragreement': 'اتفاقية العميل',
  'booking.flightrules': 'قواعد الرحلة',
  'booking.changecontacttitle': 'تغيير معلومات الاتصال',
  'booking.fullname': 'الاسم الكامل',
  'booking.address': 'العنوان',
  'booking.change': 'تغيير',
  'booking.firstname': 'الاسم',
  'booking.lastname': 'اللقب',
  'booking.departureairport': 'مطار المغادرة',
  'booking.arrivalairport': 'مطار الوصول',
  'booking.previousedays': 'اليوم السابق',
  'booking.day': 'يوم',
  'booking.month': 'شهر',
  'booking.year': 'سنة',
  'booking.changepassenger': 'تغيير عدد الركاب',
  'booking.editdepartcity': 'تحرير مدينة المغادرة',
  'booking.editdestinationcity': 'تحرير مدينة الوصول',
  'booking.editdepartdate': 'تحرير تاريخ المغادرة',
  'booking.editdestinationdate': 'تحرير تاريخ الوصول',
  'booking.changepassengernotify':
    'إذا قمت بتغيير الراكب في هذه الخطوة، ستعود إلى خطوة البحث عن الرحلة!!!!',
  'booking.edittooltip': 'يرجى النقر فوق الخاصية المرغوبة لتغيير خصائص الرحلة',
  'booking.books': 'الكتب',
  'booking.reserves': 'محجوز',
  'booking.of': 'من',
  'booking.canceled': 'ملغاة',
  'booking.history': 'التاريخ',
  'booking.searchpassengerinfo':
    'الاسم، رقم جواز السفر، الرقم الوطني، رقم الطلب، رقم التذكرة، PNR',
  'booking.issued': 'تم الإصدار',
  'booking.bought': 'تم الإصدار',
  'booking.serviceType': 'نوع الخدمة',
  'booking.serviceName': 'رحلة جوية، فندق، قطار ...',
  'booking.invoicenumber': 'رقم الطلب',
  'booking.chooseticket': 'أي تذكرة تريد إلغاؤها؟',
  'booking.cancelreturn': 'إلغاء تذكرة العودة فقط',
  'booking.cancelroundtrip': 'إلغاء جميع التذاكر',
  'booking.addflight': 'إضافة رحلة',
  'booking.showmulticity': 'عرض جميع الرحلات',
  'booking.view': 'عرض',
  'booking.takeofffrom': 'وقت الإقلاع من',
  'booking.at': 'في',
  'booking.tripsi': 'تريبسي',
  'booking.includetax': 'السعر يشمل الضرائب وجميع تكاليف الطيران',
  'booking.paymentsummery': 'ملخص الدفع',
  'booking.counter': 'عداد',
  'booking.sum': 'مجموع',
  'booking.transaction': 'تقرير المعاملات',
  'booking.countercommission': 'تقرير عمولة العداد',
  'booking.domesticflightscount': 'عدد الرحلات المحلية',
  'booking.internationalflightscount': 'عدد الرحلات الدولية',
  'booking.flightCount': 'عدد الرحلات',
  'booking.createdate': 'تاريخ الإنشاء',
  'booking.income': 'الدخل',
  'booking.notwithdrawincome': 'الدخل الغير مسحوب',
  'booking.notwithdrawpoint': 'النقاط المتبقية',
  'booking.withdrableincome': 'الدخل القابل للسحب',
  'booking.withdrablepoint': 'النقاط القابلة للسحب',
  'booking.pendingincome': 'الدخل المعلق',
  'booking.pendingpoint': 'النقاط المعلقة',
  'booking.collectedpoint': 'النقاط المجموعة',
  'booking.spentpoint': 'النقاط المنفقة',
  'booking.paymentstatus': 'حالة الدفع',
  'booking.withdrawdate': 'تاريخ السحب',
  'booking.countername': 'اسم العداد',
  'booking.canceleditting': 'إلغاء',
  'booking.nationalcode': 'الرمز الوطني',
  'booking.previousweek': 'الأسبوع السابق',
  'booking.nextweek': 'الأسبوع التالي',
  // "booking.allprice": "all prices are in Dollar",
  'booking.allprice': 'جميع الأسعار بالتومان الإيراني',
  'booking.allpriceisrial': 'جميع الأسعار بالريال الإيراني',
  'booking.showallcalendar': 'عرض مصفوفة الأسعار',
  'booking.hideallcalendar': 'إخفاء مصفوفة الأسعار',
  'booking.multicitytrip': 'رحلة متعددة المدن',
  'booking.selectstakeholder': 'اختر جهة المسؤولية الخاصة بك',
  'booking.changestakeholder': 'تغيير جهة المسؤولية',
  'booking.ticketwithoutprice': 'تذكرة بدون سعر',
  'booking.markupticket': 'تذكرة بعلامة',
  'booking.orginalticket': 'التذكرة الأصلية',
  'booking.markup': 'علامة',
  'booking.removeflight': 'إزالة الرحلة',
  'booking.continueguest': 'المتابعة كضيف',
  'booking.hotel': 'فندق',
  'booking.trackorder': 'تتبع الطلبات',
  'booking.trackingcode': 'رمز التتبع',
  'booking.searchyourorders': 'ابحث عن طلباتك',
  'booking.panel': 'لوحة',
  'booking.required': 'مطلوب',
  'booking.baggagerules': 'قوانين الأمتعة',
  'booking.userpoint': 'دریک',
  'booking.notresult': 'رمز التتبع غير صالح',
  'booking.attachpassport': 'تحميل جواز السفر',
  'booking.payhint': 'يرجى التحقق من اتفاقية العميل وقواعد الطيران للمتابعة',
  'booking.completecontactdescription': 'يرجى إكمال معلومات جهة اصدار التذكرة',
  'booking.updatepassenger': 'تحديث معلومات الراكب',
  'booking.paylater': 'الدفع لاحقًا',
  'booking.pnr': 'PNR',
  'booking.penaltyprice': 'سعر العقوبة',
  'booking.sumcancelprice': 'المبلغ القابل للاسترداد الإجمالي',
  'booking.paymenttype': 'نوع الدفع',
  'booking.chargecredit': 'شحن رصيد بطاقة الائتمان',
  'booking.chargecreditinfo':
    'سيتم خصم المبلغ من رصيد Tripsi الخاص بك لمدة تصل إلى 7 أيام عمل.',
  'booking.deposit': 'إيداع في بطاقة البنك',
  'booking.depositinfo':
    'سيتم إيداع المبلغ في الحساب المصرفي الذي تمت منه الشراء لمدة تصل إلى 7 أيام عمل كحد أقصى.',
  'booking.cancelmessage': 'تم تقديم طلب الإلغاء بنجاح وهو قيد التقدم',
  'booking.contactus': 'اتصل بفريق دعم Tripsi إذا كان هناك مشكلة',
  'booking.sendproblem': 'إرسال مشكلة',
  'booking.downloadticket': 'تحميل التذكرة',
  'booking.notrefundable': 'غير قابل للاسترداد',
  'booking.sendrequest': 'إرسال الطلب',
  'booking.withdrawtype': 'نوع السحب',
  'booking.hours': 'ساعات',
  'booking.hour': 'ساعة',
  'booking.before': 'قبل الرحلة',
  'booking.flight': 'الرحلة',
  'booking.exacttime': 'في الظهر',
  'booking.until': 'حتى',
  'booking.afterflight': 'بعد الرحلة',
  'booking.beforeflight': 'قبل الرحلة',
  'booking.after': 'حتى بعد',
  'booking.fromhours': 'من',
  'booking.agenycommission': 'عمولة الوكالة',
  'booking.unknown': 'غير معروف',
  'booking.callsupport': 'حدث خطأ أثناء إصدار التذاكر، يرجى الاتصال بالدعم.',
  'booking.searchtimeout': 'البحث عن هذه الرحلة مرة أخرى؟',
  'booking.timeout': 'وقت البحث ...',
  'booking.searchagaininfo': 'انتهى الوقت المخصص للبحث عن هذه',
  'booking.searchagaininfomsg': ' الرحلة',
  'booking.searchagian': 'نعم',
  'booking.startagain': 'لا',
  'booking.nocancelrules': 'لم يتم العثور على قواعد الإلغاء للرحلة',
  'booking.andhigher': 'وأعلى',
  'booking.printticket': 'طباعة التذكرة',
  'booking.retrivedocument': 'جارٍ استرجاع المستند ...',
  'booking.forthepassenger': 'للراكب',
  'booking.flightticket': 'تذكرة الطيران',
  'booking.ticketno': 'رقم التذكرة',
  'booking.deptime': 'وقت المغادرة',
  'booking.cancelterm':
    '1 تعتمد شروط الإلغاء للرحلات التشارتر على قواعد الجهة المقدمة للخدمة. هذا يعني أنه قد لا يمكن إلغاؤها أبدًا.',
  'booking.cancelrulehint': '2 تتوقف تكاليف الإلغاء على قواعد الطيران.',
  'booking.attention':
    'تنبيه: يُطلب من الركاب أن يكونوا حاضرين في المطار قبل الرحلة بمدة 2 ساعة.',
  'booking.valididentify':
    '3 يرجى إحضار وثائق هوية صالحة مثل بطاقة الهوية الوطنية أو شهادة الميلاد أو جواز السفر معك.',
  'booking.online': 'عبر الإنترنت',
  'booking.selectcountry': 'اختر البلد',
  'booking.calendar': 'التقويم',
  'booking.countercommissionreport': 'تقرير عمولة الكاونتر',
  'booking.hasusername': 'هل لديك اسم مستخدم؟',
  'booking.nousername': 'هل ليس لديك اسم مستخدم؟',
  'booking.signuporguest': '(الاشتراك أو كضيف)',
  'booking.guestuser': 'ضيف',
  'booking.notuserbefore': 'إنشاء حساب',
  'booking.reservationfail': 'لا يمكن حجز هذه الرحلة',
  'booking.reservationerror': 'فشل الحجز !',
  'booking.passengererror': 'خطأ في معلومات المسافرين !',
  'booking.passengerInformationHint': 'يرجى التحقق من معلومات المسافرين....',
  'booking.displayticket': 'كيفية عرض التذاكر',
  'booking.selectcustomer': 'تحديد العميل',
  'booking.asacustomer': 'تعيين العميل',
  'booking.changeticketprice': 'تغيير عرض سعر التذكرة',
  'booking.save': 'حفظ',
  'booking.fromwallet': 'المحفظة',
  'booking.fromcredit': 'الائتمان',
  'booking.frompoint': 'النقاط',
  'booking.usederik': 'ادفع سعر التذكرة باستخدام derik الخاص بك',
  'booking.yourderik': 'ديريكك: ',
  'booking.equivalentprice': 'السعر المكافئ: ',
  'booking.bookinginvoiceno': 'رقم فاتورة الحجز',
  'booking.importpnr': 'استيراد PNR',
  'booking.pnrhint': 'اختر النظام الخاص بك',
  'booking.pnrsteps': 'لاستخدام PNR، يرجى اتباع هذه الخطوات: ',
  'booking.enteryour': '1  الدخول إلى لوحة التحكم Amadeus الخاصة بك',
  'booking.openreference': '2  قم بحجزك في لوحة Amadeus. ',
  'booking.pnr3': '3  أدخل معلومات جواز السفر للمسافر بشكل كامل. ',
  'booking.entercommand': '4  أدخل رمز الأمر التالي ثم اضغط على مفتاح enter. ',
  'booking.savepnr': '5  احفظ PNR الخاص بك واضغط على مفتاح enter. ',
  'booking.pnr6':
    '6  في صفحة Tripsi، أدخل رقم PNR الخاص بك في قسم رقم المرجع. ',
  'booking.pnr7': '7  في حقل اسم الراكب الأخير، أدخله. ',
  'booking.pnr8': '8  انقر على زر الحجز. ',
  'booking.pnr9': '9  انتقل إلى صفحة الدفع بعد التحقق من المعلومات. ',
  'booking.pnr10': '10  تم إصدار تذكرتك. ',

  'booking.laststep':
    'الآن، يمكنك إدخال مرجعك في الصندوق أدناه واتباع الخطوات للتصدير. ',
  'booking.leadlastname': 'اسم العائلة للمسافر',
  'booking.usepnr': 'استيراد PNR وعرض',
  'booking.buyer': 'المشتري',
  'booking.pnrnotfound': 'لم يتم العثور على عناصر',
  'booking.uploadpassporterror': 'معلومات جواز السفر غير واضحة',
  'booking.servererror': 'هناك مشكلة في الخادم.',
  'booking.accessdenied': 'تم رفض الوصول',
  'booking.newpassenger': 'إضافة مسافر جديد',
  'booking.errormorepassenger': 'اخترت مسافرين أكثر ',
  'booking.passengertypeerror': 'نوع المسافر غير صالح',
  'booking.chooseallpassenger': 'يرجى اختيار جميع المسافرين',
  'booking.checkpassport':
    'بعد تحميل بيانات جواز السفر، يرجى التحقق من معلوماتك.',
  'booking.apply': 'تطبيق',
  'booking.flightinformation': 'معلومات الرحلة',
  'booking.adultticketprice': 'سعر الكبار',
  'booking.childticketprice': 'سعر الطفل',
  'booking.infantticketprice': 'سعر الرضيع',
  'booking.airplane': 'طائرة',
  'booking.time': 'وقت المغادرة',
  'booking.invoiceno': 'رقم الفاتورة',
  'booking.charter': 'تشارتر',
  'booking.systemic': 'نظامي',
  'booking.type': 'النوع',
  'booking.paymentprice': 'سعر الدفع',
  'booking.pnrcode': 'PNR',
  'booking.selectpayment': 'الرجاء تحديد نوع الدفع',
  'booking.temporaryreservation': 'الحجز المؤقت',
  'booking.direction': 'الاتجاه',
  'booking.passengercount': 'عدد المسافرين',
  'booking.reservesuccess': 'تم حجز تذكرتك مؤقتًا',
  'booking.passengertotalprice': 'إج مالي سعر المسافرين',
  'booking.stopduration': 'مدة التوقف',
  'booking.invalidbirthdate': 'تاريخ ميلاد غير صالح',
  'booking.invalidexpireday': 'تاريخ انتهاء صلاحية جواز السفر غير صالح',
  'booking.fullbirthdate': 'اختر تاريخ ميلادك بشكل كامل ',
  'booking.fullexpiredate': 'اختر تاريخ انتهاء صلاحية جواز السفر بشكل كامل ',
  'booking.creditpayment': 'تم الدفع من رصيدك بنجاح',
  'booking.walletpatment': 'تم الدفع من محفظتك بنجاح',
  'booking.pointpayment': 'تم الدفع من نقاطك بنجاح',
  'booking.tickettimelimit': 'محدودية زمنية للتذكرة',
  'booking.onbehalf': 'نيابةً عن',
  'booking.expirereserve': 'منتهي الصلاحية',
  'booking.person': 'شخص',
  'booking.startorderdate': 'تاريخ بدء الطلب',
  'booking.endorderdate': 'تاريخ انتهاء الطلب',
  'booking.missflight': 'فقدان الرحلة',
  'booking.multiairline': 'عدة شركات طيران',
  'booking.in': 'في',
  'booking.afterdiscount': 'بعد التخفيض',
  'booking.editissuer': 'معلومات الاتصال بالمصدر',
  'booking.referencenumber': 'رقم المرجع',
  'booking.train': 'قطار',
  'booking.bus': 'حافلة',
  'booking.economy': 'السياحية',
  'booking.business': 'درجة رجال الأعمال',
  'booking.first': 'الأولى',
  'booking.allcabinclasses':
    'سيتم عرض جميع فئات الرحلات على المسار الذي حددته.',
  'booking.findtrip': 'البحث عن رحلة',
  'booking.selectacity': 'اختر مدينة',
  'booking.destinations': 'الوجهات',
  'booking.london': 'لندن',
  'booking.rome': 'روما',
  'booking.istanbul': 'اسطنبول',
  'booking.deletePassengerTitle': 'حذف المسافر',
  'booking.invalidnationalcode': 'رمز قومي غير صالح',
  'booking.showgatewayerror': 'عرض خطأ البوابة',
  'booking.alternativefrom': 'من',
  'booking.alternativeto': 'إلى',
  'booking.commingsoon': 'قريبًا',
  'booking.searchorigin': 'البحث عن المصدر',
  'booking.searchdestination': 'البحث عن المقصد',
  'booking.plannedflight': 'الرحلة المختارة لك',
  'booking.yesterday': 'أمس',
  'booking.twodaysago': 'قبل يومين',
  'booking.englishname': 'الاسم الأول (بالإنجليزية)',
  'booking.englishlastname': 'اسم العائلة (بالإنجليزية)',
  'booking.rialtotalprice': 'السعر الإجمالي (ريال)',
  'booking.gotosearchflight': 'الانتقال إلى البحث عن رحلة',
  'booking.seat': 'مقعد',
  'booking.englishticket': 'النسخة الإنجليزية من التذكرة',
  'booking.persianticket': 'النسخة الفارسية من التذكرة',
  'booking.searchmypassenger': 'البحث عن المسافرين السابقين',
  'booking.selectairporterror': 'حدد المصدر والوجهة من الأعلى',
  'booking.providergateway': 'بوابات الخدمة',
  'booking.noresultwithfilter':
    'لم يتم العثور على نتائج باستخدام الفلتر المحدد، يرجى تغييره',
  'booking.expirereservation': 'منتهي الصلاحية',
  'booking.unpaidreservation': 'غير مدفوع',
  'booking.selectbooking': 'الرجاء تحديد التذاكر للدفع',
  'booking.mobileformaterror': 'تنسيق الجوال غير صالح',
  'booking.poweredby': 'مشغل بواسطة',
  'booking.hoteldescription': 'احجز فندقك الآن بخصم 30%',
  'booking.tourdescription':
    'جولة أوروبية لمدة 21 يومًا بمناسبة نوروز 1401. التسجيل حتى نهاية ديسمبر بخصم 5%',
  'booking.parishotel': 'فندق باريس',
  'booking.tickettitle': 'تذكرة :',
  'booking.stopdurationin': 'مدة التوقف في',
  'booking.contactInfo': 'معلومات الاتصال',
  'booking.expireDate': 'تاريخ انتهاء الصلاحية',
  'booking.pnrdesc': 'احجز في Amadeus وأصدر هنا.',
  'booking.officeid': 'معرف المكتب',
  'booking.pnrhelp': 'كتيب المستخدم',
  'booking.ticketinfo': 'تفاصيل التذكرة',
  'booking.saletotalamount': 'إجمالي المبلغ المباع',
  'booking.traveldatetime': 'وقت وتاريخ السفر',
  'booking.sale': 'بيع',
  'booking.buy': 'شراء',
  'booking.emailticket': 'تذكرة البريد الإلكتروني',
  'booking.changeticketprice': 'تغيير السعر',
  'booking.backpreviouspage': 'العودة إلى الصفحة السابقة',
  'booking.changecabinclass': 'تغيير فئة الكابينة',
  'booking.changecabinclassnotify':
    'إذا قمت بتغيير فئة الكابينة في هذه الخطوة، فسوف تعود إلى خطوة البحث عن الرحلة!!!!',
  'booking.ticketprice': 'سعر التذكرة',
  'booking.payableamount': 'المبلغ المستحق الدفع',
  'booking.showflight': 'عرض الرحلة',
  'booking.tripdirection': 'اتجاه الرحلة',
  'booking.selectpaymenttype': 'اختر نوع الدفع',
  'booking.title': 'العنوان',
  'booking.yourchoice': 'اختيارك',
  'booking.mr': 'السيد',
  'booking.mrs': 'السيدة',
  'booking.result': 'النتيجة',
  'booking.changeflight': 'تغيير مسار الرحلة',
  'booking.flightOrigin': 'الرحلة من المصدر',
  'booking.flightDestination': 'الرحلة إلى الوجهة',
  'booking.originCity': 'مدينة المصدر',
  'booking.destinationCity': 'مدينة الوجهة',
  'booking.welcometripsi': 'مرحبًا بكم في تريبسي',
  'booking.welcometripord': 'مرحبًا بكم في تريبورد',
  'booking.reservation': 'يمكن إجراء حجز مؤقت لهذه الرحلة',
  'booking.arrivetime': 'وقت الوصول',
  'booking.sortbyarrivetime': 'فرز حسب وقت الوصول',
  'booking.sortbyduration': 'فرز حسب المدة',
  'booking.tickettype': 'نوع التذكرة',
  'bookking.tehran': 'طهران',
  'booking.mashhad': 'مشهد',
  'booking.mastercard': 'بطاقة ماستركارد',
  'booking.debitCard': 'بطاقة الخصم',
  'booking.selectall': 'تحديد الكل',
  'booking.addpassenger': 'إضافة مسافر',
  'booking.textpassenger':
    'من خلال النموذج أدناه، يمكنك إدخال معلومات مسافرك وتسجيل المعلومات في النهاية. ',
  'booking.loading': 'جار التحميل...',
  'booking.showavailableflight': 'عرض الرحلات المتاحة',
  'booking.roomtype': 'نوع الغرفة',
  'booking.numberofrooms': 'عدد الغرف',
  'booking.addnewroom': 'عدد الغرف',
  'booking.picturesofroom': 'صور الغرفة',
  'booking.availsflight': 'رحلات متاحة',
  'booking.events': 'أحداث التقويم ',
  'booking.eventsinfo': 'عرض أحداث الدولة',
  'booking.want': 'أريد',
  'booking.setmaxprice': 'تحديد السعر الأقصى',
  'booking.selectcity': 'يرجى تحديد المطارات المصدر والوجهة أولاً',
  'booking.allcabinselected':
    'في الرحلات الداخلية، ستتم مطالبة بجميع فئات الرحلات',
  'booking.all': 'الكل',
  'booking.extrabed': 'أسرة إضافية',
  'booking.passportImage': 'صورة جواز السفر',
  'booking.passporthint': 'يرجى تحميل الصورة بوضوح وفقًا للعينة بحجم 700*500',
  'booking.showsample': 'عرض عينة جواز السفر',
  'booking.reservebefore': 'احجز هذه الرحلة قبل ذلك',
  'booking.editpassengersinfo': 'تعديل معلومات المسافرين',
};
